export default {
  title: 'Carga Académica',
  downloadExcel: 'Descargar Excel',
  hoursDetail: 'Detalle Horas (semanales)',
  hoursTotals: 'Totales Horas',
  maximumQuota: 'Cupo Máximo y Requisito',
  classroomType: 'Tipo de sala',
  periodicity: 'Periodicidad',
  period: 'Período (Semestre)',
  internalCode: 'Código interno de asignatura',
  code: 'Clave Asignatura',
  name: 'Nombre',
  prerequisites: 'Pre-requisito',
  pucvCredits: 'Cr. PUCV',
  sctCredits: 'Cr. SCT',
  presentialWeekly: 'Total de horas de docencia presencial Semanal',
  presentialSemester: 'Total de horas de docencia presencial Semestral',
  autonomousWeekly: 'Total de tiempo de estudio personal autónomo Semanal',
  autonomousSemester: 'Total de tiempo de estudio personal autónomo Semestral',
  dedicationWeekly: 'Total de Horas de dedicación Semanal',
  dedicationSemester: 'Total de Horas de dedicación Semestral',
  quotaJustification: 'Justificación de cupo',
  observation: 'Observación / Profesore(a)s simultáneos / Ayudantes',
  periodicities: {
    weekly: 'Semanal',
    monthly: 'Mensual',
    bimonthly: 'Bimensual',
    semiannual: 'Semestral',
  },
  selectPrerequisites: 'Seleccionar pre-requisitos',
  editPrerequisites: 'Editar pre-requisitos',
  searchMatter: 'Buscar asignatura...',
  autonomousNegative: 'Las horas presenciales ({presential}) superan las {weekly} horas semanales que permiten {credits} créditos PUCV.',
  hoursHint: 'Horas semanales. Se guardan multiplicadas por las {weeks} semanas de la asignatura.',
  closedMatter: 'Asignatura cerrada: solo lectura.',
  noMatters: 'El perfil de egreso no tiene asignaturas.',
  changeMade: 'Cambio guardado',
  codeAlreadyUsed: 'El código {code} ya está siendo utilizado por otra Asignatura Base de la institución.',
  columnsSelector: {
    subject: 'Asignatura',
    totals: 'Totales Horas',
    presential: 'Docencia presencial',
    autonomous: 'Estudio autónomo',
    dedication: 'Dedicación',
    divisions: 'Divisiones de tiempo',
    all: 'Todas',
    hours: 'Horas',
    quota: 'Cupo',
    classroomType: 'Sala',
    periodicity: 'Periodicidad',
    observation: 'Observación',
    showAll: 'Mostrar todas',
    hiddenCount: 'Columnas ({count} ocultas)',
  },
};
